import * as PostApiTypes from './PostApiTypes';
import * as PostTypes from './PostTypes';

export default {
  [PostApiTypes.POST]: PostTypes.POST,
  [PostApiTypes.TOPIC_POST]: PostTypes.POST,
  [PostApiTypes.TRIP]: PostTypes.TRIP,
  [PostApiTypes.EVENT]: PostTypes.EVENT,
  [PostApiTypes.CHECKIN]: PostTypes.CHECKIN,
};
